const DRAWER_BLEEDING = 56;

export {DRAWER_BLEEDING};
